import { getters as TYPES, DEFAULT_CONNER_PRESET, DEFAULT_BUTTON_PRESET } from '@modules/editor-sidebar/store/types';
import type { State } from '@modules/editor-sidebar/store/state';
import { presetCheckValueChanged } from '@modules/global-style';
const getters = {
  [TYPES.GET_LINKED_PRESET_ID](state: State) {
    return state.linkedPresetId || '';
  },
  [TYPES.GET_OLD_LINKED_PRESET_ID](state: State) {
    return state.oldLinkedPresetId || '';
  },
  [TYPES.GET_CURRENT_PRESET](state: State) {
    return state.currentPreset;
  },
  [TYPES.GET_CURRENT_PRESET_IN_PAGE](state: State) {
    return state.currentPresetInPage;
  },
  [TYPES.GET_CURRENT_PRESET_CORNERS](state: State) {
    if (state.presets) {
      return state.currentPreset?.presetOptions?.corners;
    }
    return DEFAULT_CONNER_PRESET;
  },
  [TYPES.GET_CURRENT_PRESET_SPACINGS](state: State) {
    if (state.presets) {
      return state.currentPreset?.presetOptions?.spacings;
    }
    return DEFAULT_CONNER_PRESET;
  },
  [TYPES.GET_CURRENT_PRESET_BORDERS](state: State) {
    if (state.presets) {
      return state.currentPreset?.presetOptions?.borders;
    }
    return DEFAULT_CONNER_PRESET;
  },
  [TYPES.GET_CURRENT_PRESET_TEXTS](state: State) {
    if (state.presets) {
      return state.currentPreset?.presetOptions?.texts;
    }
    return DEFAULT_BUTTON_PRESET;
  },
  [TYPES.GET_CURRENT_PRESET_BUTTONS](state: State) {
    if (state.currentPreset) {
      return state.currentPreset?.presetOptions?.buttons;
    }
    return DEFAULT_BUTTON_PRESET;
  },
  [TYPES.GET_CURRENT_PRESET_COLOR](state: State) {
    return state?.currentPreset?.presetOptions?.colors[0] || {};
  },
  [TYPES.GET_CURRENT_PRESET_OPTIONS](state: State) {
    return state.currentPresetOptions;
  },
  [TYPES.GET_PREVIEW_PRESET](state: State) {
    return state.previewPreset;
  },
  [TYPES.GET_PRESET_BY_PAGE_PRESET_ID](state: State, getters: any, rootState: any) {
    const presetId = rootState?.app?.pageInfo?.page?.preset_id;
    const preset = state.presets.find((item: any) => item.id == presetId);
    return preset;
  },
  [TYPES.GET_STATUS_PAGE_SAVE_GS](state: State) {
    return state.pageSavedGlobalStyle;
  },
  [TYPES.GET_IS_OPEN_SETTING](state: State) {
    return state.isOpenSetting;
  },
  [TYPES.GET_IS_CALLING_API](state: State) {
    return state.isCallingApi;
  },
  [TYPES.GET_APPLIED_GS_FOR_PAGE](state: State) {
    return state.isAppliedGsForPage;
  },
  [TYPES.PRESET_IS_EDITED](state: State) {
    if (state.currentPreset && state.presets) {
      const preset = state.presets.find((item: any) => item.id == state.currentPreset.id);
      return preset && presetCheckValueChanged(preset, state.currentPreset);
    }
    return false;
  },
};

export default getters;
